import {Component, OnInit, ViewChild} from '@angular/core';
import {MatSort, MatTableDataSource} from '@angular/material';
import { ConsultasService } from '../../services/consultas.service';
import { EstatusDescargaMasiva } from '../../Interfaces/formulario.comprobante';
import * as $ from "jquery";
declare var $: any;


/**
 * @title Table with sorting
 */
@Component({
  selector: 'app-descarga-masiva',
  templateUrl: './descarga-masiva.component.html',
  styleUrls: ['./descarga-masiva.component.css']
})
export class DescargaMasivaComponent implements OnInit {
  displayedColumns: string[] = ['fechaDeSolicitud', 'Folio' , 'tipodeDescarga', 'tipo', 'fechaDeDisponibilidad', "fechaDeVencimiento", "vecesDescargado", "ultimaDescarga","descargar"];
  dataEstatusDescargaMasiva :EstatusDescargaMasiva [];
  dataSource = new MatTableDataSource(this.dataEstatusDescargaMasiva);
  ngdetalleDescarga : EstatusDescargaMasiva;
  isLoadingResults : boolean = true;
  ngDescargas : boolean= false;
 constructor(public _ConsultasService:ConsultasService){
  this.dataEstatusDescargaMasiva;
  this.ngdetalleDescarga;
 }
  @ViewChild(MatSort) sort: MatSort;

  ngOnInit() {
    this.iniciar();
  }
iniciar(){
  this.dataSource.sort = this.sort;
  this._ConsultasService.GetEstatusDescargaMasiva().subscribe(data => {
    
    let valor : EstatusDescargaMasiva[]  //= this.dataSource.data;
    this.dataSource.data=data.estatus;
    data.estatus.length == 0 ? this.ngDescargas =true :this.ngDescargas =false;
    
    this.isLoadingResults = false;
 

  });error => console.error(error);
}
  abrirmodal(index : number){
    this.ngdetalleDescarga = this.dataSource.data[index]
    $('#modalTablaDetallesDescarga').modal('show'); // abrir
  }
  
 public descargarArchivo(index : string){
  this._ConsultasService.UpdateEstatusDescargaMasiva(this.ngdetalleDescarga.IdDescarga).subscribe(data=>{
  });
  let url  = this.ngdetalleDescarga.LinkS3[index].Link;
  window.open(url);
 }

 limpiar(){
  // this.ngdetalleDescarga="";
 }
 trackByFn(index: number, item: any) {
  // return any id
} 
}


/**  Copyright 2018 Google Inc. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license */